import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import HeatmapButton from '@Containers/ResultToolbar/HeatmapButton';
import { isHeatmapAvailable as isHeatmapAvailableSelector, isHeatmapDisabled as isHeatmapDisabledSelector } from './selectors';
import { onHeatmapButtonClick as onHeatmapButtonClickAction } from './actions';

export function PreviewResultsHeatmapButtonContainer({ isHeatmapAvailable, isHeatmapDisabled, onHeatmapButtonClick }) {
  return (
    <HeatmapButton
      isHeatmapAvailable={isHeatmapAvailable}
      isHeatmapDisabled={isHeatmapDisabled}
      onHeatmapButtonClick={onHeatmapButtonClick}
      buttonSize="md"
    />
  );
}

PreviewResultsHeatmapButtonContainer.defaultProps = {
  onHeatmapButtonClick: () => {},
};

PreviewResultsHeatmapButtonContainer.propTypes = {
  isHeatmapAvailable: PropTypes.bool,
  isHeatmapDisabled: PropTypes.bool,
  onHeatmapButtonClick: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => {
  return {
    isHeatmapAvailable: isHeatmapAvailableSelector(state, ownProps),
    isHeatmapDisabled: isHeatmapDisabledSelector(state, ownProps),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onHeatmapButtonClick: () => dispatch(onHeatmapButtonClickAction(ownProps)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PreviewResultsHeatmapButtonContainer);
